// @flow

import updateEstimateCaveatField from '../../../Services/updateEstimateCaveatField';
import type { UpdateEstimateCaveatFieldParams } from '../../../types';

export default (params: UpdateEstimateCaveatFieldParams) => async (dispatch: Function) => dispatch(updateEstimateCaveatField(params));